import React from "react";
import { Input } from "reactstrap";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import "./PreAssessmentSingleQn.scss";

const PreAssessmentSingleQn = ({ question, onChange, onDelete }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: question?.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <>
      <div
        ref={setNodeRef}
        className="d-flex gap-2 align-items-center single-input"
        style={{
          ...style,
        }}
      >
        <span
          {...attributes}
          {...listeners}
          style={{
            cursor: "grab",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <i
            className="mdi mdi-drag"
            style={{
              fontSize: "20px",
            }}
          ></i>
        </span>
        <Input
          type="textarea"
          name="jobDescription"
          id="jobDescription"
          placeholder="Enter job description here..."
          value={question?.question}
          onChange={(e) => {
            onChange(e);
          }}
          style={{
            width: "100%",
            height: "auto",
          }}
        />
        <span className="hide cursor-pointer" onClick={onDelete}>
          <span className="d-flex align-items-center justify-content-center single-delete">
            <i
              className="ri-delete-bin-line"
              style={{
                color: "red",
              }}
            ></i>
          </span>
        </span>
      </div>
    </>
  );
};

export default PreAssessmentSingleQn;
